const validateEditorState = (editorState) => {
  const result = [];

  if (!editorState.oldPassword) {
    result.push({
      param: 'oldPassword',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.newPassword) {
    result.push({
      param: 'newPassword',
      userMessage: 'Pole wymagane',
    });
  }

  return result.length > 0 ? result : null;
};

export default validateEditorState;
